import { render, staticRenderFns } from "./PreTrialNotices.vue?vue&type=template&id=159f78d8&scoped=true&"
import script from "./PreTrialNotices.vue?vue&type=script&lang=js&"
export * from "./PreTrialNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f78d8",
  null
  
)

export default component.exports